export default {"src":"/_next/static/media/youtube.b7b848ec.svg","height":816,"width":1184,"blurWidth":0,"blurHeight":0};